import styled from 'styled-components';

/*
====================================
HEADER FIJO
====================================
*/

export const HeaderExportacionFijo =
    styled.div`

        position:
            sticky;

        top:
            0;

        z-index:
            1000;

        width:
            100%;

        background:
            #FFFFFF;

    `;


/*
====================================
PÁGINA
====================================
*/

export const Pagina =
    styled.div`

        width: 100%;
        min-height: 100vh;

        background:
            #F5F7F8;

        padding:
            28px 28px 60px 28px;

        box-sizing:
            border-box;

        color:
            #1F2A30;

        font-family:
            'Nunito',
            system-ui,
            sans-serif;


        @media (
            max-width: 720px
        ) {

            padding:
                18px 16px 40px 16px;

        }

    `;


export const Contenedor =
    styled.div`

        width:
            100%;

        max-width:
            1260px;

        margin:
            0 auto;

    `;


/*
====================================
ENCABEZADO
====================================
*/

export const Encabezado =
    styled.div`

        display:
            flex;

        align-items:
            flex-end;

        justify-content:
            space-between;

        gap:
            16px;

        flex-wrap:
            wrap;

        margin-bottom:
            22px;

    `;


export const BloqueTitulo =
    styled.div`

        min-width:
            0;

    `;


export const Titulo =
    styled.h1`

        margin:
            0;

        color:
            #1F2A30;

        font-family:
            'Montserrat',
            'Nunito',
            system-ui,
            sans-serif;

        font-size:
            24px;

        font-weight:
            800;

        line-height:
            1.2;

    `;


export const Subtitulo =
    styled.p`

        margin:
            6px 0 0 0;

        max-width:
            620px;

        color:
            #6B7780;

        font-size:
            14px;

        line-height:
            1.45;

    `;


export const BotonFantasma =
    styled.button`

        border:
            1px solid #E3E7EA;

        border-radius:
            10px;

        background:
            #FFFFFF;

        padding:
            9px 14px;

        display:
            inline-flex;

        align-items:
            center;

        gap:
            7px;

        color:
            #0E7A7E;

        font-family:
            inherit;

        font-size:
            13px;

        font-weight:
            700;

        cursor:
            pointer;

        transition:
            border-color 0.15s ease;


        &:hover {

            border-color:
                #0E7A7E;

        }

    `;


/*
====================================
GRID PRINCIPAL
====================================
*/

export const GridPrincipal =
    styled.div`

        display:
            grid;

        grid-template-columns:
            minmax(
                0,
                1fr
            )
            370px;

        gap:
            20px;

        align-items:
            start;


        @media (
            max-width: 1000px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


/*
====================================
TARJETAS
====================================
*/

export const Tarjeta =
    styled.section`

        background:
            #FFFFFF;

        border:
            1px solid #E3E7EA;

        border-radius:
            16px;

        padding:
            20px;

        box-sizing:
            border-box;

    `;


export const TituloTarjeta =
    styled.h2`

        margin:
            0;

        color:
            #1F2A30;

        font-family:
            'Montserrat',
            'Nunito',
            system-ui,
            sans-serif;

        font-size:
            15.5px;

        font-weight:
            800;

    `;


export const SubtituloTarjeta =
    styled.div`

        margin-top:
            3px;

        color:
            #6B7780;

        font-size:
            12.5px;

        line-height:
            1.4;

    `;


/*
====================================
TOOLBAR
====================================
*/

export const Toolbar =
    styled.div`

        display:
            flex;

        align-items:
            center;

        gap:
            10px;

        flex-wrap:
            wrap;

        margin:
            16px 0 12px 0;

    `;


export const Buscador =
    styled.div`

        flex:
            1;

        min-width:
            200px;

        position:
            relative;

    `;


export const IconoBuscar =
    styled.svg`

        position:
            absolute;

        left:
            11px;

        top:
            50%;

        transform:
            translateY(-50%);

        width:
            16px;

        height:
            16px;

        fill:
            none;

        stroke:
            #6B7780;

        stroke-width:
            2;

        pointer-events:
            none;

    `;


export const InputBuscar =
    styled.input`

        width:
            100%;

        border:
            1px solid #E3E7EA;

        border-radius:
            10px;

        padding:
            10px 12px 10px 36px;

        background:
            #FAFBFB;

        outline:
            none;

        font-family:
            inherit;

        font-size:
            13px;

        color:
            #1F2A30;

        box-sizing:
            border-box;


        &:focus {

            border-color:
                #0E7A7E;

            background:
                #FFFFFF;

        }

    `;


/*
====================================
FILTROS
====================================
*/

export const Segmentos =
    styled.div`

        display:
            flex;

        padding:
            3px;

        background:
            #F0F3F4;

        border-radius:
            10px;

    `;


export const BotonSegmento =
    styled.button`

        border:
            none;

        border-radius:
            8px;

        padding:
            7px 12px;

        background:
            ${
                props =>
                    props.$activo
                        ?
                        '#FFFFFF'
                        :
                        'transparent'
            };

        box-shadow:
            ${
                props =>
                    props.$activo
                        ?
                        '0 1px 2px rgba(0,0,0,.08)'
                        :
                        'none'
            };

        color:
            ${
                props =>
                    props.$activo
                        ?
                        '#1F2A30'
                        :
                        '#6B7780'
            };

        font-family:
            inherit;

        font-size:
            12.5px;

        font-weight:
            700;

        cursor:
            pointer;

    `;


/*
====================================
CABECERA DEL LISTADO
====================================
*/

export const CabeceraLista =
    styled.div`

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            12px;

        padding:
            10px 12px;

        border-bottom:
            1px solid #E3E7EA;

        color:
            #6B7780;

        font-size:
            12.5px;

        font-weight:
            700;

    `;


export const LabelSeleccionTodos =
    styled.label`

        display:
            flex;

        align-items:
            center;

        gap:
            9px;

        color:
            #1F2A30;

        cursor:
            pointer;

    `;


export const Check =
    styled.input`

        width:
            17px;

        height:
            17px;

        margin:
            0;

        accent-color:
            #0E7A7E;

        cursor:
            pointer;

        flex:
            none;

    `;


export const ContadorSeleccion =
    styled.span`

        background:
            #E7F3F3;

        color:
            #0E7A7E;

        border-radius:
            20px;

        padding:
            3px 10px;

        font-size:
            11.5px;

        font-weight:
            800;

        white-space:
            nowrap;

    `;


/*
====================================
LISTA DE PACIENTES
====================================
*/

export const ListaPacientes =
    styled.div`

        width:
            100%;

    `;


export const FilaPaciente =
    styled.div`

        display:
            grid;

        grid-template-columns:
            24px
            minmax(
                0,
                1fr
            )
            auto
            220px;

        gap:
            12px;

        align-items:
            center;

        padding:
            12px;

        border-bottom:
            1px solid #E3E7EA;

        border-left:
            3px solid ${
                props =>
                    props.$seleccionado
                        ?
                        '#0E7A7E'
                        :
                        'transparent'
            };

        background:
            ${
                props =>
                    props.$seleccionado
                        ?
                        '#F6FBFB'
                        :
                        '#FFFFFF'
            };

        transition:
            background 0.15s ease,
            border-color 0.15s ease;


        &:hover {

            background:
                #FAFCFC;

        }


        &:last-child {

            border-bottom:
                none;

        }


        @media (
            max-width: 720px
        ) {

            grid-template-columns:
                22px
                minmax(
                    0,
                    1fr
                )
                auto;

            row-gap:
                8px;

        }

    `;


export const BloquePaciente =
    styled.div`

        min-width:
            0;

    `;


export const NombrePaciente =
    styled.div`

        color:
            #1F2A30;

        font-size:
            13px;

        font-weight:
            800;

    `;


export const MetaPaciente =
    styled.div`

        margin-top:
            2px;

        color:
            #6B7780;

        font-size:
            12px;

        line-height:
            1.3;

    `;


export const BadgeEstado =
    styled.span`

        padding:
            3px 9px;

        border-radius:
            20px;

        white-space:
            nowrap;

        font-size:
            11px;

        font-weight:
            800;

        background:
            ${
                props =>
                    props.$archivado
                        ?
                        '#EEF0F2'
                        :
                        '#E8F4ED'
            };

        color:
            ${
                props =>
                    props.$archivado
                        ?
                        '#6B7780'
                        :
                        '#4E9B6E'
            };

    `;


/*
====================================
SELECT DE PERÍODO
====================================
*/

export const SelectorPeriodo =
    styled.div`

        width:
            100%;


        @media (
            max-width: 720px
        ) {

            grid-column:
                1 / -1;

        }

    `;


export const SelectPeriodo =
    styled.select`

        width:
            100%;

        border:
            1px solid #E3E7EA;

        border-radius:
            9px;

        padding:
            8px 10px;

        background:
            #FFFFFF;

        outline:
            none;

        font-family:
            inherit;

        font-size:
            13px;

        color:
            #1F2A30;

        box-sizing:
            border-box;


        &:focus {

            border-color:
                #0E7A7E;

        }


        &:disabled {

            background:
                #F4F6F7;

            color:
                #A9B1B7;

            cursor:
                not-allowed;

        }

    `;


export const TextoPeriodoIndividual =
    styled.div`

        margin-top:
            4px;

        color:
            #D9852C;

        font-size:
            11px;

        font-weight:
            800;

    `;


/*
====================================
COLUMNA LATERAL
====================================
*/

export const ColumnaLateral =
    styled.aside`

        display:
            flex;

        flex-direction:
            column;

        gap:
            20px;

        position:
            sticky;

        top:
            84px;


        @media (
            max-width: 1000px
        ) {

            position:
                static;

        }

    `;


/*
====================================
PRESETS
====================================
*/

export const Presets =
    styled.div`

        display:
            grid;

        grid-template-columns:
            1fr 1fr;

        gap:
            7px;

        margin-top:
            14px;

    `;


export const BotonPreset =
    styled.button`

        border:
            1px solid ${
                props =>
                    props.$activo
                        ?
                        '#0E7A7E'
                        :
                        '#E3E7EA'
            };

        border-radius:
            9px;

        padding:
            9px 8px;

        background:
            ${
                props =>
                    props.$activo
                        ?
                        '#E7F3F3'
                        :
                        '#FFFFFF'
            };

        color:
            ${
                props =>
                    props.$activo
                        ?
                        '#0E7A7E'
                        :
                        '#1F2A30'
            };

        text-align:
            left;

        font-family:
            inherit;

        font-size:
            12.5px;

        font-weight:
            700;

        cursor:
            pointer;

    `;


export const TextoAyuda =
    styled.div`

        margin-top:
            10px;

        color:
            #6B7780;

        font-size:
            12px;

        line-height:
            1.45;

    `;


/*
====================================
RESUMEN
====================================
*/

export const ResumenGrid =
    styled.div`

        display:
            grid;

        grid-template-columns:
            1fr 1fr;

        gap:
            10px;

        margin-top:
            14px;

    `;


export const Stat =
    styled.div`

        background:
            #F7F9FA;

        border-radius:
            12px;

        padding:
            12px;

        min-width:
            0;

    `;


export const StatValor =
    styled.b`

        display:
            block;

        color:
            ${
                props =>
                    props.$naranja
                        ?
                        '#D9852C'
                        :
                        '#0E7A7E'
            };

        font-family:
            'Montserrat',
            'Nunito',
            system-ui,
            sans-serif;

        font-size:
            ${
                props =>
                    props.$pequenio
                        ?
                        '14px'
                        :
                        '22px'
            };

        font-weight:
            800;

        overflow-wrap:
            anywhere;

    `;


export const StatLabel =
    styled.span`

        color:
            #6B7780;

        font-size:
            12px;

        font-weight:
            700;

        line-height:
            1.3;

    `;


/*
====================================
NOTAS
====================================
*/

export const Nota =
    styled.div`

        display:
            flex;

        gap:
            9px;

        margin-top:
            12px;

        padding:
            11px 12px;

        border-radius:
            11px;

        background:
            ${
                props =>
                    props.$tipo ===
                    'advertencia'
                        ?
                        '#FDF2E4'
                        :
                        '#E7F3F3'
            };

        color:
            ${
                props =>
                    props.$tipo ===
                    'advertencia'
                        ?
                        '#7A4A12'
                        :
                        '#0A6266'
            };

        font-size:
            12.5px;

        line-height:
            1.4;


        svg {

            width:
                17px;

            height:
                17px;

            flex:
                none;

            margin-top:
                1px;

            fill:
                none;

            stroke:
                currentColor;

            stroke-width:
                2;

        }

    `;


/*
====================================
BOTÓN PRINCIPAL
====================================
*/

export const MensajeProximamente =
    styled.div`

        margin-top:
            12px;

        color:
            #D9852C;

        font-size:
            12px;

        font-weight:
            800;

    `;


export const BotonPrincipal =
    styled.button`

        width:
            100%;

        margin-top:
            14px;

        border:
            none;

        border-radius:
            11px;

        padding:
            13px;

        background:
            #F1A350;

        color:
            #FFFFFF;

        font-family:
            'Montserrat',
            'Nunito',
            system-ui,
            sans-serif;

        font-size:
            13px;

        font-weight:
            700;

        cursor:
            pointer;

        transition:
            background 0.15s ease;


        &:hover:not(:disabled) {

            background:
                #D9852C;

        }


        &:disabled {

            background:
                #E5D5C2;

            cursor:
                not-allowed;

        }

    `;


/*
====================================
YA EXPORTADO
====================================
*/

export const SeccionExportados =
    styled.div`

        margin-top:
            20px;

        scroll-margin-top:
            90px;

    `;


export const TablaContenedor =
    styled.div`

        width:
            100%;

        margin-top:
            12px;

        overflow-x:
            auto;

    `;


export const Tabla =
    styled.table`

        width:
            100%;

        border-collapse:
            collapse;

        font-size:
            13px;

        color:
            #1F2A30;


        tr:hover td {

            background:
                #FAFCFC;

        }

    `;


export const TH =
    styled.th`

        padding:
            9px 10px;

        border-bottom:
            1px solid #E3E7EA;

        text-align:
            left;

        color:
            #6B7780;

        font-size:
            11.5px;

        font-weight:
            800;

        text-transform:
            uppercase;

        letter-spacing:
            0.4px;

        white-space:
            nowrap;

    `;

/*
====================================
BOTÓN ORDEN TABLA
====================================
*/

export const BotonOrdenTabla =
    styled.button`

        display:
            inline-flex;

        align-items:
            center;

        gap:
            5px;

        margin:
            0;

        padding:
            0;

        border:
            none;

        background:
            transparent;

        color:
            ${
                props =>
                    props.$activo
                        ?
                        '#0E7A7E'
                        :
                        '#6B7780'
            };

        font-family:
            inherit;

        font-size:
            inherit;

        font-weight:
            inherit;

        text-transform:
            inherit;

        letter-spacing:
            inherit;

        white-space:
            nowrap;

        cursor:
            pointer;

        transition:
            color 0.15s ease;


        &:hover {

            color:
                #0E7A7E;

        }


        &:focus-visible {

            outline:
                2px solid #B8DEDF;

            outline-offset:
                3px;

            border-radius:
                3px;

        }


        span {

            min-width:
                12px;

            color:
                ${
                    props =>
                        props.$activo
                            ?
                            '#0E7A7E'
                            :
                            '#A6AEB4'
                };

            font-size:
                12px;

            font-weight:
                800;

            line-height:
                1;

            text-align:
                center;

        }

    `;

export const TD =
    styled.td`

        padding:
            11px 10px;

        border-bottom:
            1px solid #E3E7EA;

        vertical-align:
            middle;

        font-size:
            13px;

    `;


/*
====================================
ESTADOS VACÍOS
====================================
*/

export const EstadoVacio =
    styled.div`

        min-height:
            180px;

        display:
            flex;

        flex-direction:
            column;

        align-items:
            center;

        justify-content:
            center;

        text-align:
            center;

        padding:
            30px;

        box-sizing:
            border-box;

    `;


export const EstadoVacioTitulo =
    styled.div`

        color:
            #1F2A30;

        font-size:
            14px;

        font-weight:
            800;

    `;


export const EstadoVacioTexto =
    styled.div`

        max-width:
            480px;

        margin-top:
            6px;

        color:
            #6B7780;

        font-size:
            12.5px;

        line-height:
            1.45;

    `;

/*
====================================
MODAL EXPORTACIÓN
====================================
*/

export const FondoModal =
    styled.div`

        position:
            fixed;

        inset:
            0;

        z-index:
            3000;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        padding:
            20px;

        background:
            rgba(
                20,
                35,
                40,
                0.45
            );

        box-sizing:
            border-box;

    `;


export const ModalExportacion =
    styled.div`

        width:
            min(
                520px,
                100%
            );

        max-height:
            90vh;

        overflow-y:
            auto;

        background:
            #FFFFFF;

        border-radius:
            18px;

        box-shadow:
            0 20px 60px
            rgba(
                0,
                0,
                0,
                0.25
            );

    `;


export const CabeceraModal =
    styled.div`

        display:
            flex;

        align-items:
            flex-start;

        justify-content:
            space-between;

        gap:
            20px;

        padding:
            18px 22px;

        border-bottom:
            1px solid #E3E7EA;

    `;


export const TituloModal =
    styled.h2`

        margin:
            0;

        color:
            #1F2A30;

        font-family:
            'Montserrat',
            'Nunito',
            system-ui,
            sans-serif;

        font-size:
            17px;

        font-weight:
            800;

    `;


export const TextoModal =
    styled.div`

        margin-top:
            5px;

        color:
            #6B7780;

        font-size:
            12.5px;

        line-height:
            1.45;

    `;


export const BotonCerrarModal =
    styled.button`

        width:
            32px;

        height:
            32px;

        flex:
            none;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        border:
            none;

        border-radius:
            50%;

        background:
            #F0F3F4;

        color:
            #6B7780;

        font-family:
            inherit;

        font-size:
            20px;

        line-height:
            1;

        cursor:
            pointer;


        &:disabled {

            cursor:
                not-allowed;

            opacity:
                0.6;

        }

    `;


export const CuerpoModal =
    styled.div`

        padding:
            20px 22px 22px 22px;

    `;


export const ResumenModal =
    styled.div`

        overflow:
            hidden;

        margin-bottom:
            18px;

        border:
            1px solid #E3E7EA;

        border-radius:
            11px;

        background:
            #FAFBFB;

    `;


export const FilaResumenModal =
    styled.div`

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            15px;

        padding:
            10px 12px;

        border-bottom:
            1px solid #E3E7EA;


        &:last-child {

            border-bottom:
                none;

        }

    `;


export const LabelModal =
    styled.span`

        color:
            #6B7780;

        font-size:
            12px;

        font-weight:
            700;

    `;


export const ValorModal =
    styled.span`

        color:
            #1F2A30;

        font-size:
            12.5px;

        font-weight:
            800;

        text-align:
            right;

    `;


export const CampoModal =
    styled.div`

        margin-top:
            16px;

    `;


export const LabelCampoModal =
    styled.label`

        display:
            block;

        margin-bottom:
            6px;

        color:
            #6B7780;

        font-size:
            11.5px;

        font-weight:
            800;

        text-transform:
            uppercase;

        letter-spacing:
            0.4px;

    `;


export const InputModal =
    styled.input`

        width:
            100%;

        padding:
            10px 11px;

        border:
            1px solid #E3E7EA;

        border-radius:
            9px;

        background:
            #FFFFFF;

        color:
            #1F2A30;

        font-family:
            inherit;

        font-size:
            13px;

        outline:
            none;

        box-sizing:
            border-box;


        &:focus {

            border-color:
                #0E7A7E;

        }


        &:disabled {

            background:
                #F4F6F7;

        }

    `;


export const ErrorModal =
    styled.div`

        margin-top:
            12px;

        padding:
            10px 12px;

        border-radius:
            9px;

        background:
            #FBE9F0;

        color:
            #A53B63;

        font-size:
            12.5px;

        font-weight:
            700;

    `;


export const ExitoModal =
    styled.div`

        margin-top:
            12px;

        padding:
            10px 12px;

        border-radius:
            9px;

        background:
            #E8F4ED;

        color:
            #4E9B6E;

        font-size:
            12.5px;

        font-weight:
            800;

    `;


export const AccionesModal =
    styled.div`

        display:
            flex;

        align-items:
            center;

        justify-content:
            flex-end;

        gap:
            10px;

        margin-top:
            20px;


        @media (
            max-width: 500px
        ) {

            flex-direction:
                column-reverse;

            align-items:
                stretch;

        }

    `;


export const BotonCancelarModal =
    styled.button`

        padding:
            10px 16px;

        border:
            1px solid #E3E7EA;

        border-radius:
            9px;

        background:
            #FFFFFF;

        color:
            #6B7780;

        font-family:
            inherit;

        font-size:
            13px;

        font-weight:
            700;

        cursor:
            pointer;


        &:disabled {

            cursor:
                not-allowed;

            opacity:
                0.6;

        }

    `;


export const BotonConfirmarModal =
    styled.button`

        padding:
            11px 18px;

        border:
            none;

        border-radius:
            9px;

        background:
            #F1A350;

        color:
            #FFFFFF;

        font-family:
            'Montserrat',
            'Nunito',
            system-ui,
            sans-serif;

        font-size:
            12.5px;

        font-weight:
            700;

        cursor:
            pointer;


        &:hover:not(:disabled) {

            background:
                #D9852C;

        }


        &:disabled {

            background:
                #E5D5C2;

            cursor:
                not-allowed;

        }

    `;

/*
====================================
ACCIONES ENCABEZADO
====================================
*/

export const AccionesEncabezado =
    styled.div`

        display:
            flex;

        align-items:
            center;

        gap:
            9px;

    `;


/*
====================================
BOTÓN AYUDA
====================================
*/

export const BotonAyudaExportacion =
    styled.button`

        width:
            24px;

        height:
            24px;

        min-width:
            24px;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        padding:
            0;

        border:
            1.5px solid #655EE8;

        border-radius:
            50%;

        background-color:
            #FFFFFF;

        color:
            #655EE8;

        font-family:
            inherit;

        font-size:
            0.78rem;

        font-weight:
            800;

        cursor:
            pointer;


        &:hover {

            background-color:
                #F3F1FF;

        }

    `;


/*
====================================
VOLVER A DESCARGAR
====================================
*/

export const BotonReDescargar =
    styled.button`

        padding:
            7px 10px;

        border:
            1px solid #0E7A7E;

        border-radius:
            8px;

        background:
            #FFFFFF;

        color:
            #0E7A7E;

        font-family:
            inherit;

        font-size:
            11.5px;

        font-weight:
            800;

        white-space:
            nowrap;

        cursor:
            pointer;


        &:hover:not(:disabled) {

            background:
                #E7F3F3;

        }


        &:disabled {

            border-color:
                #D7DCDD;

            color:
                #A4ACB0;

            background:
                #F5F6F7;

            cursor:
                not-allowed;

        }

    `;